import { createFileRoute } from '@tanstack/react-router';
import { PayoutsPage } from '@/features/payouts/pages/payouts-page';

export const Route = createFileRoute('/_app/payouts')({ component: PayoutsPage });
